import { Injectable } from '@angular/core';
import { AccessoryCharge } from '@cargos/sprintpay-models';
import { AccessorieService } from '@cargos/sprintpay-services';
import { Observable, map, take } from 'rxjs';
import { CurrentFacilityService } from '../current-facility.service';
import { SummaryService } from '../summary/summary.service';
import { AccessoriesService } from './accessories.service';

@Injectable()
export class AccessoriesDefaultImplementationService extends AccessoriesService {
    constructor(
        private currentFacilityService: CurrentFacilityService,
        private summaryService: SummaryService,
        private accessorieService: AccessorieService
    ) {
        super();
    }

    fetchAccessories(destination?: string): Observable<AccessoryCharge[]> {
        const facility = this.currentFacilityService.getFacilitySource();
        const location = destination ? destination : this.summaryService.getLocation() || '';

        return this.accessorieService.getAccessories(facility, location).pipe(
            take(1),
            map((accessories: AccessoryCharge[]) => this.filterAccessoriesWithOutRate(accessories)),
            map((accessories: AccessoryCharge[]) => this.sortAccessoriesByType(accessories))
        );
    }
}
